




import Class from './c-meter-view';
export default Class;
